<template>
  <div
    ref="tabBarItemRootRef"
    :class="
      classes(
        n(),
      )
    "
    :style="tabBarItemRootStyle"
    @click="onClick"
  >
    <!-- 图标区 -->
    <div

      :class="
        classes(
          n('icon'),
          [activeStatus, n('icon--active')]
        )
      "
    >
      <component :is="icon" />
      <Badge
        v-show="badgeProps"
        v-bind="badgeProps"
        :class="classes(
          n('badge'),
          badgeOffsetClassName,
        )"
      />
    </div>
    <!-- 默认插槽（文本） -->
    <div
      :class="
        classes(
          n('label'),
          [activeStatus, n('label--active')]
        )
      "
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, nextTick, onMounted, ref } from 'virtual-vue';
import { tabBarItemProps } from './props';
import { useTabBarInject } from './provide';
import Badge from '../badge/badge.vue';
import { createNamespace } from '../utils/components';
import { BadgeProps } from '../badge';
import { TabBarItemBadgeType } from './tab-bar';

const { name, n, classes } = createNamespace('tab-bar-item');

export default defineComponent({
  name,
  components: {
    Badge,
  },
  props: tabBarItemProps,
  setup(props) {
    const { activeIndex, updateChild } = useTabBarInject();

    const tabBarItemRootRef = ref<HTMLDivElement>();

    const tabBarItemRootStyle = ref<Record<string, string>>({
      [`--${n()}-width`]: undefined,
    });

    const activeStatus = computed(() => props.index === activeIndex.value);

    const icon = computed(() => (activeStatus.value ? props.icons.active : props.icons.inactive));

    const badgeProps = computed<BadgeProps | undefined>(() => {
      const { badge } = props;
      // 未传入badge || 未传入text时，不渲染badge
      if (
        !badge
        || (
          badge.type !== TabBarItemBadgeType.Dot
          && !badge.text
        )
      ) return undefined;

      if (badge.type === TabBarItemBadgeType.Dot) {
        return {
          dot: true,
          size: 'large',
        };
      }
      if (badge.type === TabBarItemBadgeType.Number) {
        return {
          shape: 'circle',
          text: badge.text,
          size: 'small',
        };
      }
      if (badge.type === TabBarItemBadgeType.AutoCapsule) {
        return {
          shape: 'square',
          text: badge.text,
          size: 'small',
        };
      }
      // 其他情况，不渲染badge
      return undefined;
    });

    const badgeOffsetClassName = computed(() => {
      const { badge } = props;
      if (badge?.type === TabBarItemBadgeType.Dot) return n('badge-dot');
      if (badge?.type === TabBarItemBadgeType.Number) return n('badge-number');
      if (badge?.type === TabBarItemBadgeType.AutoCapsule) return n('badge-auto-capsule');
      return '';
    });

    function onClick() {
      updateChild(props.index);
    }

    onMounted(() => {
      tabBarItemRootStyle.value[`--${n()}-width`] = `${tabBarItemRootRef.value.offsetWidth}px`;
    });

    return {
      icon,
      tabBarItemRootRef,
      badgeProps,
      badgeOffsetClassName,
      activeIndex,
      activeStatus,
      tabBarItemRootStyle,
      n,
      classes,
      onClick,
    };
  },
});
</script>
